import type { Control, OptionId } from "src/api";
import { Explained } from "./Explained";
import { TapCell } from "./sectionStyles";

/** One tap. The mock's `.tap` / `.tap.on`. */
export function Tap({
  item,
  choose,
  beside
}: {
  item: Control;
  choose(option: OptionId): void;
  beside: HTMLElement | null;
}) {
  return (
    <Explained item={item} beside={beside}>
      <TapCell
        data-testid={item.id}
        aria-pressed={item.on}
        aria-label={item.label}
        // Off is `aria-disabled`, never the native attribute — `Control`'s
        // ruling, and it is what keeps the hover card reachable on a tap the
        // clock has switched off (§29 U1).
        aria-disabled={item.enabled ? undefined : true}
        onClick={item.enabled ? () => choose(item.option) : undefined}
      >
        {item.on ? "✓" : "–"}
      </TapCell>
    </Explained>
  );
}
